import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import vajra from '../../assets/img/vajra.png';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import LineWeightIcon from '@mui/icons-material/LineWeight';
import BuildIcon from '@mui/icons-material/Build';
import DescriptionIcon from '@mui/icons-material/Description';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import TaskIcon from '@mui/icons-material/Task';
import PolicyIcon from '@mui/icons-material/Policy';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import LoginIcon from '@mui/icons-material/Login';
import MenuIcon from '@mui/icons-material/Menu';
import { Box } from '@mui/material';

const Sidebar = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const closeSidebar = () => {
    setShowSidebar(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (windowWidth >= 600) {
      setShowSidebar(true);
    }
  }, [windowWidth]);

  return (
    <div className="sidebar-container">
      <div className={`sidebar ${showSidebar ? 'show' : ''}`}>
        <div className="img-vajra">
          <img src={vajra} alt="" />
        </div>
        <Box className="home" >
          <HomeOutlinedIcon sx={{
          width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
          height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
          fontSize: {xs: "20px"}
        }} />
        </Box>
        <div className="user">
          <Person2OutlinedIcon sx={{
          width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
          height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
          fontSize: {xs: "20px"}
        }}/>
        </div>
        <div className="group">
          <GroupOutlinedIcon sx={{
          width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
          height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
          fontSize: {xs: "20px"}
        }}/>
        </div>
        <div className="line">
          <LineWeightIcon sx={{
          width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
          height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
          fontSize: {xs: "20px"}
        }}/>
        </div>
        <div className="line_23">
          <BuildIcon sx={{
          width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
          height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
          fontSize: {xs: "20px"}
        }}/>
        </div>
        <div className="line_2">
          <DescriptionIcon sx={{
          width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
          height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
          fontSize: {xs: "20px"}
        }}/>
        </div>
        <div className="icons">
          <SaveAsIcon sx={{
          width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
          height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
          fontSize: {xs: "20px"}
        }}/>
        </div>
        <div className="task">
          <TaskIcon sx={{
          width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
          height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
          fontSize: {xs: "20px"}
        }}/>
        </div>
        <div className="task_2">
          <PolicyIcon sx={{
          width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
          height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
          fontSize: {xs: "20px"}
        }}/>
        </div>
        <div className="head">
          <HeadsetMicIcon sx={{
          width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
          height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
          fontSize: {xs: "20px"}
        }}/>
        </div>
        <div className="login">
          <LoginIcon sx={{
          width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
          height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
          fontSize: {xs: "20px"}
        }}/>
        </div>
      </div>
      {windowWidth < 600 && (
        <div className="mobile-menu" onClick={toggleSidebar}>
          {showSidebar ? (
            <span className="close-icon" onClick={toggleSidebar}>
              <MenuIcon sx={{
              width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
              height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
              fontSize: {xs: "20px"},
              marginTop: {xs: "5px"},
              marginLeft: {xs: "-2px"}
            }}/>
            </span>
          ) : (
            <MenuIcon sx={{
              width: { xl: "27px", lg: "27px", md: "27px", sm: "27px", },
              height: { xl: "31px", lg: "31px", md: "31px", sm: "31px", },
              fontSize: {xs: "20px"}
            }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Sidebar;
